import { NgModule } from '@angular/core';

// Servicios
import { SxSecurityService, AuthenticatedGuard } from './services/sxSecurity.service';
import { SxHttpService } from './services/sxHttp.service';
import { JwtService } from './services/jwt.service';
import { RememberMeService } from './services/rememberme.service';
import { SubscriptionsService } from './services/subscriptions.service';
import { LoaderService } from './services/loader.service';
import { AlertService } from './services/alert.service';
import { FormulariosService } from './services/formularios.service';
import { ContactosService } from './services/contactos.service';
import { ChannelsService } from './services/channels.service';
import { ProductsService } from './services/products.service';
import { ConfigService } from './services/config.service';
import { RuleService } from './services/reglas.service';
import { TipoSolicitudService } from './services/tiposolicitud.service';
import { AssetsService } from './services/assets.service';
import { OpcionesService } from './services/opciones.service';
import { ComandosService } from './services/comandos.service';
import { RolesService } from './services/roles.service';
import { OutputService } from './services/output.service';
import { AzureFileManagerService } from './services/azureFileManager.service';
import {  ItemLibraryService } from './services/itemLibrary.service';

// Mock API
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDatos } from './services/inmemory/memory-datos.service';
import { UsuariosService } from './services/usuarios.service';
import { HistorialService } from './services/historial.service';
import { ConsultaSimpleService } from './services/consultaSimple.service';
import { ParametrosService } from './services/parametros.service';
import { ImportacionMasivaService } from './services/importacionMasiva.service';
import { AuthService } from './services/auth.service';
import { SxContextService } from './services/sxContext.service';
import { SxRouterService } from './services/sxRouter.service';
import { SettingsService } from './services/settings.service';
import { PortalTemplatesService } from './services/portalTemplates.service';
import { CatalogoProductosService } from './services/catalogoProductos.service';
import { DiagnosticoService } from './services/diagnostico.service';
import { VentaAsyncService } from './services/ventaAsync.service';
import { CotizacionAsyncService } from './services/cotizacionAsync.service';
import { MonitoreoService } from './services/monitoreo.service';
import { SelectsService } from './services/selects.service';
import { ProvidersService } from './services/providers.service';
import { SuscripcionesService } from './services/suscripciones.service';
import { CategoriasService } from './services/categorias.service';
import { CategoriaProductosService } from './services/categoria-productos.service';
import { ProductFlowService } from './services/productFlow.service';
import { SxfPageDesignerService } from 'app/private/sxfdesigner/services/page-service';
import { SOCUsersConfigService } from './services/socUserConfig.service';
import { ErrorMessageService } from './services/error.service';
import { PaymentGatewayService } from './services/payment.gateways.service';
import { ExternalComponentService } from './services/externalComponent.service';
import { RuleBuilderService } from './services/ruleBuilder.service';
import { ReportConfigurationService } from './services/reportConfiguration.service';
import { DigitalLibraryService } from './services/digitalLibrary.service';
import { ProductReportService } from './services/productreport.service';
import { ProductEmailService } from './services/productEmail.service';
import { AuthorizationConfigurationService } from './services/authorizationConfiguration.service';
import { TimeZoneService } from './services/timeZoneService.service';
import { OrganizationService } from './services/organization.service';
import { CategoryService } from './services/category.service';
import { ViewEngineService } from './services/viewengine.service';
import { PublishPortalService } from './services/publishPortal.service';
import { BusinessLogicService } from './services/businessLogic.service';
import { DataLogicService } from './services/dataLogic.service';
import { StandardDictionaryService } from './services/standarddictionary.service';
import { CategoryListService } from './services/categoryList.service';
import { PageListService } from './services/pageList.service';
import { NonTransactionalFlowService } from './services/non-transactional-flow.service';
import { ConfigurationTypeService } from './services/configurationType.service';
import { MarketplaceService } from './services/marketplace.service';

/**
 * Directivas para exportar
 */
const DIRECTIVES = [];

@NgModule({
  providers: [
    // Servicios
    MarketplaceService,
    SxfPageDesignerService,
    SxSecurityService,
    SxHttpService,
    JwtService,
    RememberMeService,
    SubscriptionsService,
    OrganizationService,
    LoaderService,
    AlertService,
    FormulariosService,
    ContactosService,
    ChannelsService,
    ProductsService,
    PublishPortalService,
    DataLogicService,
    BusinessLogicService,
    CategoryListService,
    PageListService,
    StandardDictionaryService,
    ConfigService,
    RuleService,
    FormulariosService,
    TipoSolicitudService,
    AssetsService,
    OpcionesService,
    ComandosService,
    UsuariosService,
    HistorialService,
    ConsultaSimpleService,
    ParametrosService,
    ImportacionMasivaService,
    AuthService,
    SxContextService,
    SxRouterService,
    SettingsService,
    PortalTemplatesService,
    CatalogoProductosService,
    DiagnosticoService,
    VentaAsyncService,
    CotizacionAsyncService,
    MonitoreoService,
    SelectsService,
    ProvidersService,
    SuscripcionesService,
    CategoriasService,
    CategoryService,
    CategoriaProductosService,
    ProductFlowService,
    RolesService,
    OutputService,
    PaymentGatewayService,
    ViewEngineService,
    AzureFileManagerService,
    MonitoreoService,
    SOCUsersConfigService,
    ErrorMessageService,
    ItemLibraryService,
    RuleBuilderService,
    ExternalComponentService,
    ReportConfigurationService,
    DigitalLibraryService,
    ProductReportService,
    ProductEmailService,
    AuthorizationConfigurationService,
    ConfigurationTypeService,
    NonTransactionalFlowService,
    // Guardas
    AuthenticatedGuard,
    TimeZoneService
  ],
  declarations: DIRECTIVES,
  exports: DIRECTIVES,
  imports: [
    InMemoryWebApiModule.forRoot(InMemoryDatos, {
      passThruUnknownUrl: true
    }),
  ]
})
export class InfrastructureModule {
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/infrastructure.module.ts